import request from './axios'
export function getcustomList(data) {
  return request({
    url: `/lx/api/business/getAllCustomer`,
    method: 'post',
    data
  })
}
// 查看详情
export function getdetailsList(data) {
  return request({
    url: `/lx/api/business/getAllProjectByCustomerName`,
    method: 'post',
    data
  })
}
// 删除
export function deleteId(id) {
  return request({
    url: `/lx/api/business/${id}`,
    method: 'DELETE'
  })
}
